export const pricePackageANumeric = 2249;
export const pricePackageBNumeric = 3248;
export const pricePackageCNumeric = 1725;
export const pricePackageA = `€ ${pricePackageANumeric}`;
export const pricePackageB = `€ ${pricePackageBNumeric}`;
